// extracted by mini-css-extract-plugin
module.exports = {"dashboard-list__item":"Home_dashboard-list__item__3B65W","div-botton":"Home_div-botton__23D-4"};